import Vue from 'vue'
import VueApollo from 'vue-apollo'
import 'cross-fetch/polyfill'
import { createApolloClient, restartWebsockets } from 'vue-cli-plugin-apollo/graphql-client/src'
import Cookie from 'universal-cookie'
import { InMemoryCache } from 'apollo-cache-inmemory'

Vue.use(VueApollo)

export default (ctx, inject) => {
  const providerOptions = { clients: {} }
  const { app, beforeNuxtRender, req } = ctx
  const AUTH_TOKEN_NAME = 'apollo-token'
  const COOKIE_ATTRIBUTES = {"expires":7,"path":"\u002F","secure":false}
  const AUTH_TYPE = 'Bearer '
  const cookies = new Cookie(req && req.headers.cookie)

  // Config

      const defaultTokenName = ''  || AUTH_TOKEN_NAME

      function defaultGetAuth () {
        const token = cookies.get(defaultTokenName)
        return token && defaultClientConfig.validateToken(token) ? AUTH_TYPE + token : ''
      }

      let defaultClientConfig

        defaultClientConfig = require('~/apollo/networkInterface.js')

        if ('default' in defaultClientConfig) {
          defaultClientConfig = defaultClientConfig.default
        }

        defaultClientConfig = defaultClientConfig(ctx)

      const defaultValidateToken = () => true

      if (!defaultClientConfig.validateToken) {
        defaultClientConfig.validateToken = defaultValidateToken
      }

      const defaultCache = defaultClientConfig.cache
        ? defaultClientConfig.cache
        : new InMemoryCache(defaultClientConfig.inMemoryCacheOptions ? defaultClientConfig.inMemoryCacheOptions: undefined)

      if (!process.server) {
        defaultCache.restore(window.__NUXT__ && window.__NUXT__.apollo ? window.__NUXT__.apollo.defaultClient : null)
      }

      if (!defaultClientConfig.getAuth) {
        defaultClientConfig.getAuth = defaultGetAuth
      }

      if (process.client && defaultClientConfig.browserHttpEndpoint) {
        defaultClientConfig.httpEndpoint = defaultClientConfig.browserHttpEndpoint
      }

      defaultClientConfig.ssr = !!process.server
      defaultClientConfig.cache = defaultCache
      defaultClientConfig.tokenName = defaultTokenName

      // if ssr we'd still like to have our webclient's cookies
      if (process.server && req && req.headers && req.headers.cookie) {
        if (!defaultClientConfig.httpLinkOptions) {
          defaultClientConfig.httpLinkOptions = {}
        }
        if (!defaultClientConfig.httpLinkOptions.headers) {
          defaultClientConfig.httpLinkOptions.headers = {}
        }
        defaultClientConfig.httpLinkOptions.headers.cookie = req.headers.cookie
      }

      // Create apollo client
      let defaultApolloCreation = createApolloClient({
        ...defaultClientConfig
      })
      defaultApolloCreation.apolloClient.wsClient = defaultApolloCreation.wsClient

          providerOptions.defaultClient = defaultApolloCreation.apolloClient

      const uploadTokenName = ''  || AUTH_TOKEN_NAME

      function uploadGetAuth () {
        const token = cookies.get(uploadTokenName)
        return token && uploadClientConfig.validateToken(token) ? AUTH_TYPE + token : ''
      }

      let uploadClientConfig

        uploadClientConfig = require('~/apollo/uploadInterface.js')

        if ('default' in uploadClientConfig) {
          uploadClientConfig = uploadClientConfig.default
        }

        uploadClientConfig = uploadClientConfig(ctx)

      const uploadValidateToken = () => true

      if (!uploadClientConfig.validateToken) {
        uploadClientConfig.validateToken = uploadValidateToken
      }

      const uploadCache = uploadClientConfig.cache
        ? uploadClientConfig.cache
        : new InMemoryCache(uploadClientConfig.inMemoryCacheOptions ? uploadClientConfig.inMemoryCacheOptions: undefined)

      if (!process.server) {
        uploadCache.restore(window.__NUXT__ && window.__NUXT__.apollo ? window.__NUXT__.apollo.upload : null)
      }

      if (!uploadClientConfig.getAuth) {
        uploadClientConfig.getAuth = uploadGetAuth
      }

      if (process.client && uploadClientConfig.browserHttpEndpoint) {
        uploadClientConfig.httpEndpoint = uploadClientConfig.browserHttpEndpoint
      }

      uploadClientConfig.ssr = !!process.server
      uploadClientConfig.cache = uploadCache
      uploadClientConfig.tokenName = uploadTokenName

      // if ssr we'd still like to have our webclient's cookies
      if (process.server && req && req.headers && req.headers.cookie) {
        if (!uploadClientConfig.httpLinkOptions) {
          uploadClientConfig.httpLinkOptions = {}
        }
        if (!uploadClientConfig.httpLinkOptions.headers) {
          uploadClientConfig.httpLinkOptions.headers = {}
        }
        uploadClientConfig.httpLinkOptions.headers.cookie = req.headers.cookie
      }

      // Create apollo client
      let uploadApolloCreation = createApolloClient({
        ...uploadClientConfig
      })
      uploadApolloCreation.apolloClient.wsClient = uploadApolloCreation.wsClient

          providerOptions.clients.upload = uploadApolloCreation.apolloClient

      const cmsTokenName = ''  || AUTH_TOKEN_NAME

      function cmsGetAuth () {
        const token = cookies.get(cmsTokenName)
        return token && cmsClientConfig.validateToken(token) ? AUTH_TYPE + token : ''
      }

      let cmsClientConfig

        cmsClientConfig = require('~/apollo/cmsInterface.js')

        if ('default' in cmsClientConfig) {
          cmsClientConfig = cmsClientConfig.default
        }

        cmsClientConfig = cmsClientConfig(ctx)

      const cmsValidateToken = () => true

      if (!cmsClientConfig.validateToken) {
        cmsClientConfig.validateToken = cmsValidateToken
      }

      const cmsCache = cmsClientConfig.cache
        ? cmsClientConfig.cache
        : new InMemoryCache(cmsClientConfig.inMemoryCacheOptions ? cmsClientConfig.inMemoryCacheOptions: undefined)

      if (!process.server) {
        cmsCache.restore(window.__NUXT__ && window.__NUXT__.apollo ? window.__NUXT__.apollo.cms : null)
      }

      if (!cmsClientConfig.getAuth) {
        cmsClientConfig.getAuth = cmsGetAuth
      }

      if (process.client && cmsClientConfig.browserHttpEndpoint) {
        cmsClientConfig.httpEndpoint = cmsClientConfig.browserHttpEndpoint
      }

      cmsClientConfig.ssr = !!process.server
      cmsClientConfig.cache = cmsCache
      cmsClientConfig.tokenName = cmsTokenName

      // if ssr we'd still like to have our webclient's cookies
      if (process.server && req && req.headers && req.headers.cookie) {
        if (!cmsClientConfig.httpLinkOptions) {
          cmsClientConfig.httpLinkOptions = {}
        }
        if (!cmsClientConfig.httpLinkOptions.headers) {
          cmsClientConfig.httpLinkOptions.headers = {}
        }
        cmsClientConfig.httpLinkOptions.headers.cookie = req.headers.cookie
      }

      // Create apollo client
      let cmsApolloCreation = createApolloClient({
        ...cmsClientConfig
      })
      cmsApolloCreation.apolloClient.wsClient = cmsApolloCreation.wsClient

          providerOptions.clients.cms = cmsApolloCreation.apolloClient

  const vueApolloOptions = Object.assign(providerOptions, {
      errorHandler (error) {
          console.log('%cError', 'background: red; color: white; padding: 2px 4px; border-radius: 3px; font-weight: bold;', error.message)
      }
  })

  const apolloProvider = new VueApollo(vueApolloOptions)
  // Allow access to the provider in the context
  app.apolloProvider = apolloProvider

  if (process.server) {
    const ApolloSSR = require('vue-apollo/ssr')
    beforeNuxtRender(({ nuxtState }) => {
      nuxtState.apollo = ApolloSSR.getStates(apolloProvider)
    })
  }

  inject('apolloHelpers', {
    onLogin: async (token, apolloClient = apolloProvider.defaultClient, cookieAttributes = COOKIE_ATTRIBUTES, skipResetStore = false) => {
      // Fallback for tokenExpires param
      if (typeof cookieAttributes === 'number') cookieAttributes = { expires: cookieAttributes }

      if (typeof cookieAttributes.expires === 'number') {
        cookieAttributes.expires = new Date(Date.now()+ 86400*1000*cookieAttributes.expires)
      }

      if (token) {
        cookies.set(AUTH_TOKEN_NAME, token, cookieAttributes)
      } else {
        cookies.remove(AUTH_TOKEN_NAME, cookieAttributes)
      }
      if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient)
      if (!skipResetStore) {
        try {
          await apolloClient.resetStore()
        } catch (e) {
          // eslint-disable-next-line no-console
          console.log('%cError on cache reset (setToken)', 'color: orange;', e.message)
        }
      }
    },
    onLogout: async (apolloClient = apolloProvider.defaultClient, skipResetStore = false) => {
      cookies.remove(AUTH_TOKEN_NAME, COOKIE_ATTRIBUTES)
      if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient)
      if (!skipResetStore) {
        try {
          await apolloClient.resetStore()
        } catch (e) {
          // eslint-disable-next-line no-console
          console.log('%cError on cache reset (logout)', 'color: orange;', e.message)
        }
      }
    },
    getToken: (tokenName = AUTH_TOKEN_NAME) => {
      return cookies.get(tokenName)
    }
  })
}
